<template>
  <div class="procurement-plan">
    <div class="container">
      <tab
        :tabsValue="activeIndex"
        :tabPaneData="tabArr"
        @tabClick="handleTab"
        style="margin-bottom: 20px"
      />
      <e-search
        :list-type-info="listTypeInfo"
        style="margin-bottom: 20px"
        :count="100"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <e-table-list
        :index-show="true"
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :reserve-selection="false"
        class="margin-b20"
      >
        <template #operate="slot">
          <eui-btn
            type="link"
            size="20"
            class="blue-box"
            v-if="activeIndex == 0"
            @click="
              handlePlan(
                '1',
                slot.scope.row.purchasePlanId,
                slot.scope.row.businessAuditId
              )
            "
          >
            审批
          </eui-btn>
          <eui-btn
            type="link"
            size="20"
            class="blue-box"
            @click="handlePlan('2', slot.scope.row.purchasePlanId)"
          >
            查看详情
          </eui-btn>
        </template>
      </e-table-list>
      <div class="pagination">
        <el-pagination
          style="margin-top: 20px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :total="queryData.pageTotal"
          :page-size.sync="queryData.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import Tab from '@/modules/projectA/components/common/e-tabs.vue';
import Api from '@/modules/projectA/api/auditManagement/index';

export default {
  name: 'ProcurementPlan',
  components: { eSearch, eTableList, Tab },
  data() {
    return {
      activeIndex: '0',
      tabArr: [
        {
          label: '待审批',
          id: '0',
        },
        {
          label: '已审批',
          id: '1',
        },
      ],
      listTypeInfo: {
        statusList: [
          { name: '全部', id: null },
          { name: '新建', id: 1 },
          { name: '待审核', id: 2 },
          { name: '审核通过', id: 3 },
          { name: '驳回', id: 4 },
        ],
      },
      loading: false,
      filterInfo: {
        data: {
          purchasePlanName: null,
          purchasePlanCode: null,
          createTime: null,
        },
        fieldList: [
          { label: '采购计划名称', type: 'input', value: 'purchasePlanName' },
          { label: '采购计划编号', type: 'input', value: 'purchasePlanCode' },
          {
            label: '提交日期',
            type: 'date',
            value: 'createTime',
            dateType: 'daterange',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            defaultTime: ['00:00:00', '23:59:59'],
          },
          // {label: "状态", type: "select", value: "", list: "statusList",},
        ],
        /**配置项 */
        btnStyle: [{ text: '查询', type: 'primary' }, { text: '重置' }],
      },
      tableData: [],
      tableLabel: [
        { label: '采购计划编号', param: 'purchasePlanCode', align: 'center' },
        { label: '采购计划名称', param: 'purchasePlanName', align: 'center' },
        { label: '提交日期', param: 'submitTime', align: 'center' },
        { label: '创建人', param: 'createMemberName', align: 'center' },
        {
          label: '审核状态',
          param: 'auditStatus',
          align: 'center',
          render: (row) => {
            if (row.auditStatus == 0) {
              return '待审批';
            } else if (row.auditStatus == 1) {
              return '审批通过';
            } else if (row.auditStatus == 2) {
              return '审批拒绝';
            }
          },
        },
        { label: '操作', param: '', align: 'center', slot: 'operate' },
      ],
      queryData: {
        purchasePlanName: '',
        purchasePlanCode: '',
        submitTimeStart: '',
        submitTimeEnd: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  methods: {
    handlePlan(flag, purchasePlanId, businessAuditId) {
      this.$router.push({
        path: '/auditManagement/procurementPlan/procurementPlanDetail',
        query: {
          flag: flag,
          purchasePlanId: purchasePlanId,
          businessAuditId: businessAuditId,
        },
      });
    },
    handleTab(row) {
      this.queryData = {
        purchasePlanName: '',
        purchasePlanCode: '',
        submitTimeStart: '',
        submitTimeEnd: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      };

      this.activeIndex = row.name;
      if (this.activeIndex == '1') {
        this.queryPlanApprovedPage();
      } else {
        this.queryPlanAuditPage();
      }
    },
    async queryPlanApprovedPage() {
      let res = await Api.queryPlanApprovedPage(this.queryData);
      if (res.code == '200') {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total || 0;
      }
    },
    handleReset() {
      this.queryData = {
        purchasePlanName: '',
        purchasePlanCode: '',
        submitTimeStart: '',
        submitTimeEnd: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      };
      if (this.activeIndex == '1') {
        this.queryPlanApprovedPage();
      } else {
        this.queryPlanAuditPage();
      }
    },
    handleFilter(val) {
      this.queryData.purchasePlanName = val.purchasePlanName
        ? val.purchasePlanName
        : null;
      this.queryData.purchasePlanCode = val.purchasePlanCode
        ? val.purchasePlanCode
        : null;
      this.queryData.submitTimeStart =
        val.createTime && val.createTime.length > 0 ? val.createTime[0] : null;
      this.queryData.submitTimeEnd =
        val.createTime && val.createTime.length > 0 ? val.createTime[1] : null;
      if (this.activeIndex == '1') {
        this.queryPlanApprovedPage();
      } else {
        this.queryPlanAuditPage();
      }
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      if (this.activeIndex == '1') {
        this.queryPlanApprovedPage();
      } else {
        this.queryPlanAuditPage();
      }
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      if (this.activeIndex == '1') {
        this.queryPlanApprovedPage();
      } else {
        this.queryPlanAuditPage();
      }
    },
    async queryPlanAuditPage() {
      let res = await Api.queryPlanAuditPage(this.queryData);
      if (res.code == '200') {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total || 0;
      }
    },
  },
  mounted() {
    this.queryPlanAuditPage();
  },
};
</script>

<style scoped lang="scss">
.procurement-plan {
  // background: #fff;
}
.blue-box {
  color: #2f80ed;
  cursor: pointer;
  &:hover {
    border-bottom: 1px solid #2f80ed;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
}
</style>
